import React, { FC, InputHTMLAttributes } from 'react'

import { formatNumber } from '../../utils/format'
import * as S from './ControlButtonsFilter.styles'
import { FilterButtonControlProps } from './ControlButtonsFilter.types'

type ControlButtonFilterProps = FilterButtonControlProps & InputHTMLAttributes<HTMLInputElement>

export const ControlButtonFilter: FC<ControlButtonFilterProps> = ({
  id,
  checked,
  defaultChecked,
  multipleSelect,
  count,
  disabled,
  label,
  title,
  children,
  className,
  onClick,
  ...inputProps
}) => {
  return (
    <S.ButtonContainer>
      <S.HiddenControlInput
        type={multipleSelect ? 'checkbox' : 'radio'}
        id={id}
        defaultChecked={defaultChecked}
        checked={checked}
        name={label}
        className={className}
        disabled={disabled}
        onClick={onClick}
        {...inputProps}
      />

      <S.ControlDefault htmlFor={id} checked={checked} disabled={disabled}>
        <S.Title>
          {title}
          {children && <S.ControlChildren>{children}</S.ControlChildren>}
          {count !== undefined && (
            <S.AmountBadge selected={checked}>{formatNumber(count)}</S.AmountBadge>
          )}
        </S.Title>
      </S.ControlDefault>
    </S.ButtonContainer>
  )
}
